export default "__VITE_ASSET__BAgMmIli__"